import { sortDestinationIdFormat } from "@redotech/redo-ids-cockroach";
import * as z from "zod";

export const printSortDestinationBarcodes = {
  name: "printSortDestinationBarcodes" as const,
  input: z.object({ ids: z.array(sortDestinationIdFormat.schema).optional() }),
  output: z.object({ url: z.string() }),
};
